var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cms-view",
    {
      directives: [
        {
          name: "spinner",
          rawName: "v-spinner",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: { hide: _vm.loading },
    },
    [
      _c(
        "cms-heading",
        { attrs: { title: _vm.pageTitle } },
        [
          _vm.itemId
            ? _c(
                "cms-button",
                {
                  attrs: { color: "negative", icon: "magicon-trash" },
                  on: { click: _vm.deleteProject },
                },
                [_vm._v("Verwijderen")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "cms-form-panel",
        {
          attrs: {
            "submit-button": "Opslaan",
            "cancel-button": true,
            submitting: _vm.submitting,
          },
          on: { submit: _vm.submit },
        },
        [
          _c("cms-form-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: {
              title: "Titel",
              name: "title",
              "data-vv-as": "Titel",
              error: _vm.error("title"),
            },
            model: {
              value: _vm.pendingProject.title,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingProject,
                  "title",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "pendingProject.title",
            },
          }),
          _c("cms-form-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: {
              title: "Projectcode",
              name: "code",
              disabled: _vm.project != null,
              "data-vv-as": "Projectcode",
              error: _vm.error("code"),
            },
            model: {
              value: _vm.pendingProject.code,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingProject,
                  "code",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "pendingProject.code",
            },
          }),
          _c("cms-form-date-picker", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'",
              },
            ],
            attrs: {
              title: "Start datum",
              name: "startDate",
              input: "true",
              options: { disableMobile: true },
              "data-vv-as": "Start datum",
              error: _vm.error("startDate"),
            },
            model: {
              value: _vm.pendingProject.startDate,
              callback: function ($$v) {
                _vm.$set(_vm.pendingProject, "startDate", $$v)
              },
              expression: "pendingProject.startDate",
            },
          }),
          _c("cms-form-date-picker", {
            attrs: {
              title: "Eind datum",
              name: "endDate",
              input: "true",
              options: { disableMobile: true },
            },
            model: {
              value: _vm.pendingProject.endDate,
              callback: function ($$v) {
                _vm.$set(_vm.pendingProject, "endDate", $$v)
              },
              expression: "pendingProject.endDate",
            },
          }),
          _c("cms-form-dropdown", {
            attrs: {
              title: "Munisense groep",
              name: "munisenseGroupId",
              searchable: true,
              empty: "- Geen -",
              options: _vm.munisenseGroupOptions,
            },
            model: {
              value: _vm.pendingProject.munisenseGroupId,
              callback: function ($$v) {
                _vm.$set(_vm.pendingProject, "munisenseGroupId", $$v)
              },
              expression: "pendingProject.munisenseGroupId",
            },
          }),
          _c(
            "cms-form-row",
            { attrs: { title: "Locatie" } },
            [
              _c("gmap-autocomplete", {
                ref: "autocompleteInput",
                staticClass: "input-normal",
                attrs: {
                  value: _vm.pendingProject.locationTitle,
                  "select-first-on-enter": true,
                },
                on: { place_changed: _vm.setPlace },
              }),
              _c("i", { staticClass: "svg icon-search-dark" }),
            ],
            1
          ),
          _c("cms-form-input", {
            attrs: {
              title: "Locatie omschrijving",
              hint: "Wanneer niet ingevuld wordt de bovenstaande locatie benaming gebruikt.",
              name: "locationManual",
            },
            model: {
              value: _vm.pendingProject.locationManual,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingProject,
                  "locationManual",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "pendingProject.locationManual",
            },
          }),
          _c("cms-form-input", {
            attrs: { title: "Projectleider", name: "projectManager" },
            model: {
              value: _vm.pendingProject.projectManager,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingProject,
                  "projectManager",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "pendingProject.projectManager",
            },
          }),
          _c("cms-form-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "min_value:0",
                expression: "'min_value:0'",
              },
            ],
            attrs: {
              type: "number",
              min: "0",
              name: "actionDeadline",
              placeholder: _vm.deadlinePlaceholder,
              title: "Afhandelingstermijn",
              hint: "In dagen",
              "data-vv-as": "Afhandelingstermijn",
              error: _vm.error("actionDeadline"),
            },
            model: {
              value: _vm.pendingProject.actionDeadline,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingProject,
                  "actionDeadline",
                  _vm._n(typeof $$v === "string" ? $$v.trim() : $$v)
                )
              },
              expression: "pendingProject.actionDeadline",
            },
          }),
          _c("cms-form-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "min_value:0",
                expression: "'min_value:0'",
              },
            ],
            attrs: {
              type: "number",
              min: "0",
              name: "loggerDailyPriceMultiplier",
              title: "Korting/toeslag loggerkosten",
              hint: "Vermenigvuldigingsfactor (0,9 is 90% van de kosten en 1,1 is 110% van de kosten)",
              "data-vv-as": "Korting/toeslag loggerkosten",
              error: _vm.error("loggerDailyPriceMultiplier"),
            },
            model: {
              value: _vm.pendingProject.loggerDailyPriceMultiplier,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingProject,
                  "loggerDailyPriceMultiplier",
                  _vm._n(typeof $$v === "string" ? $$v.trim() : $$v)
                )
              },
              expression: "pendingProject.loggerDailyPriceMultiplier",
            },
          }),
          _c("cms-form-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "min_value:0",
                expression: "'min_value:0'",
              },
            ],
            attrs: {
              type: "number",
              min: "0",
              name: "loggerUsagePriceMultiplier",
              title: "Korting/toeslag portalkosten",
              hint: "Vermenigvuldigingsfactor (0,9 is 90% van de kosten en 1,1 is 110% van de kosten)",
              "data-vv-as": "Korting/toeslag portalkosten",
              error: _vm.error("loggerUsagePriceMultiplier"),
            },
            model: {
              value: _vm.pendingProject.loggerUsagePriceMultiplier,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingProject,
                  "loggerUsagePriceMultiplier",
                  _vm._n(typeof $$v === "string" ? $$v.trim() : $$v)
                )
              },
              expression: "pendingProject.loggerUsagePriceMultiplier",
            },
          }),
          _c("cms-form-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "min_value:0",
                expression: "'min_value:0'",
              },
            ],
            attrs: {
              type: "number",
              min: "0",
              name: "loggerBackofficePriceMultiplier",
              title: "Korting/toeslag backoffice kosten",
              hint: "Vermenigvuldigingsfactor (0,9 is 90% van de kosten en 1,1 is 110% van de kosten)",
              "data-vv-as": "Korting/toeslag backoffice kosten",
              error: _vm.error("loggerBackofficePriceMultiplier"),
            },
            model: {
              value: _vm.pendingProject.loggerBackofficePriceMultiplier,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingProject,
                  "loggerBackofficePriceMultiplier",
                  _vm._n(typeof $$v === "string" ? $$v.trim() : $$v)
                )
              },
              expression: "pendingProject.loggerBackofficePriceMultiplier",
            },
          }),
          _c("cms-form-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "min_value:0",
                expression: "'min_value:0'",
              },
            ],
            attrs: {
              type: "number",
              min: "0",
              name: "loggerFailurePriceMultiplier",
              title: "Korting/toeslag storingskosten",
              hint: "Vermenigvuldigingsfactor (0,9 is 90% van de kosten en 1,1 is 110% van de kosten)",
              "data-vv-as": "Korting/toeslag storingskosten",
              error: _vm.error("loggerFailurePriceMultiplier"),
            },
            model: {
              value: _vm.pendingProject.loggerFailurePriceMultiplier,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingProject,
                  "loggerFailurePriceMultiplier",
                  _vm._n(typeof $$v === "string" ? $$v.trim() : $$v)
                )
              },
              expression: "pendingProject.loggerFailurePriceMultiplier",
            },
          }),
          _c("cms-form-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "min_value:0",
                expression: "'min_value:0'",
              },
            ],
            attrs: {
              type: "number",
              min: "0",
              name: "loggerManualRoundPriceMultiplier",
              title: "Korting/toeslag handmeetrondekosten",
              hint: "Vermenigvuldigingsfactor (0,9 is 90% van de kosten en 1,1 is 110% van de kosten)",
              "data-vv-as": "Korting/toeslag handmeetrondekosten",
              error: _vm.error("loggerManualRoundPriceMultiplier"),
            },
            model: {
              value: _vm.pendingProject.loggerManualRoundPriceMultiplier,
              callback: function ($$v) {
                _vm.$set(
                  _vm.pendingProject,
                  "loggerManualRoundPriceMultiplier",
                  _vm._n(typeof $$v === "string" ? $$v.trim() : $$v)
                )
              },
              expression: "pendingProject.loggerManualRoundPriceMultiplier",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }